// extracted by mini-css-extract-plugin
export default {"page":"j8-z","cartModal":"k8-z","checkout":"l8-z","placeholder":"m8-z","account":"n8-z"};